import { AsyncReturnType, FirstParameter } from 'vtils/types'
import { loadResourceData, submit } from '@/utils'
import { ref, watch } from '@vue/composition-api'

export function useLoadResourceData(
  payload: () =>
    | FirstParameter<typeof loadResourceData>['x']
    | null
    | undefined,
  name = 'x',
  noLoading = false,
) {
  const data = ref<AsyncReturnType<typeof loadResourceData>['x']>([])

  watch(
    payload,
    () => {
      const y = payload()
      if (!y) {
        data.value = []
        return
      }
      submit(async $ => {
        if (!noLoading) {
          $.start()
        }
        const { [name]: x } = await loadResourceData({
          [name]: y,
        })
        data.value = x
      })
    },
    {
      immediate: true,
    },
  )

  return data
}
